namespace Portico.Models.Legacy {
    
    export class PatientSearchResultModel {
        results: Array<PatientSearchRecordModel>;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.PatientSearchResultModel){
            this.results = null;

            if(obj){
                this.results = (obj.results || []).map(item => new PatientSearchRecordModel(item || null));
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.PatientSearchResultModel {
            return {
                results: this.results.map(item => item.toModel()),
            };
        }
    }   
}